import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const {
    t
  } = useLanguage();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };
  return <section className="bg-[#1d1d1f] py-24 md:py-32 px-6 relative overflow-hidden" id="contact" data-id="element-238">
      {/* Texture Overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-239" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-241">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-242">
            {t.newsletter.label}
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-white mb-6" data-id="element-243">
            {t.newsletter.title}
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-244" />
          <p className="text-[#86868b] text-[18px] md:text-[20px] mb-12 font-light max-w-2xl mx-auto" data-id="element-245">
            {t.newsletter.description}
          </p>
        </motion.div>

        <motion.form initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto" data-id="element-246">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={t.newsletter.placeholder} className="flex-1 px-8 py-4 bg-white/5 border border-white/10 text-white placeholder-[#86868b] focus:outline-none focus:border-[#c9a961] transition-colors duration-300 rounded-sm" aria-label="Email Address" required data-id="element-247" />
          <button type="submit" className="px-10 py-4 bg-[#c9a961] text-black font-medium text-[14px] uppercase tracking-wide hover:bg-[#d4b872] transition-colors duration-300 min-w-[160px] rounded-sm" data-id="element-248">
            {t.newsletter.button}
          </button>
        </motion.form>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-[#86868b] text-[13px] mt-8 font-light" data-id="element-249">
          {t.newsletter.disclaimer}
        </motion.p>
      </div>
    </section>;
}